import api from 'api';

export const loadPresets = api('GET /api/home-dashboard/filters/presets');
